module.exports = __webpack_public_path__ + "img/truck-sm-green.4aab082c.svg";